export const COLORS = {
  bg: "#F8F7F4",
  surface: "#FFFFFF",
  surfaceAlt: "#F1F0EC",
  border: "#E2E0DA",
  borderLight: "#ECEAE4",
  text: "#1A1917",
  textSecondary: "#6B6860",
  textMuted: "#9C9889",
  accent: "#2B5CE6",
  accentLight: "#EBF0FD",
  accentHover: "#1E4AD4",
  green: "#1A8754",
  greenLight: "#E8F5EF",
  orange: "#C4720A",
  orangeLight: "#FFF4E5",
  red: "#C53030",
  redLight: "#FEE7E7",
  purple: "#6B46C1",
  purpleLight: "#F0EBFA",
};
